import * as React from "react";

import { Link } from "react-router-dom";

import { cn } from "~/lib/utils";

export function MainNav({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <nav
      className={cn("flex items-center space-x-4 lg:space-x-6", className)}
      {...props}
    >
      <Link
        to="/"
        className="text-sm font-medium transition-colors hover:text-primary"
      >
        Dashboard
      </Link>
      <Link
        to="/clients"
        className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
      >
        Clientes
      </Link>
      <Link
        to="/sales-notes"
        className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
      >
        Notas de Venta
      </Link>
      <Link
        to="/facturas/visualizar"
        className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
      >
        Facturas
      </Link>
      <Link
        to="/products"
        className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
      >
        Productos
      </Link>
    </nav>
  );
}
